module.exports = __webpack_public_path__ + "static/media/23154839_1638423612899490_5108082280029942599_o.e9a40522.jpg";